import {Button, Card} from 'antd'
import React, {useCallback, useEffect, useRef, useState} from 'react'
import {News} from '../../entities/news'
import urlProjectPhoto0 from 'url:../../../public/assets/images/image1.jpg'
const {Meta} = Card
import {CalendarOutlined, RightOutlined} from '@ant-design/icons'
import {Link} from 'react-router-dom'
import './newsList.less'
import './home.less'
import {useIntl} from 'react-intl'
import dayjs from 'dayjs'
import {NewsCard} from './NewsCard'

export type NewsListProps = {
  newsList: News[]
  type: 'news' | 'tutorials'
}

// these must match home.less (.home-layout__news-list): the first card track,
// the small card width and the gap between them. Overestimating how many cards
// fit makes the right column wrap into extra rows and overlap the content below.
const firstCardWidth = 480
const cardWidth = 280
const cardGap = 24

const fullCardWidth = cardWidth + cardGap

export function NewsList(props: NewsListProps) {
  const [firstCardIndex, setFirstCardIndex] = useState(0)
  const newsListContainerRef = useRef<HTMLDivElement>(null)

  const [newsPerView, setNewsPerView] = useState(1)

  const intl = useIntl()

  const recalculateNewsPerView = useCallback(() => {
    if (!newsListContainerRef.current) {
      return
    }

    const containerWidth = newsListContainerRef.current.clientWidth
    const cardsToDisplay = Math.floor((containerWidth - firstCardWidth) / fullCardWidth) * 2 + 1
    setNewsPerView(cardsToDisplay < 1 ? 1 : cardsToDisplay)
  }, [setNewsPerView])

  useEffect(() => {
    const callback = recalculateNewsPerView
    callback()

    window.addEventListener('resize', callback)
    return () => window.removeEventListener('resize', callback)
  }, [])

  const newsToDisplay: News[] = []

  for (let i = 0; i < newsPerView; i++) {
    let currentIndex = (i + firstCardIndex) % props.newsList.length
    newsToDisplay.push(props.newsList[currentIndex])
  }

  return (
    <div
      className="home-layout__news-list"
      // style={{
      //   display: 'flex',
      //   flexDirection: 'row',
      //   overflowX: 'hidden',
      //   overflowY: 'visible',
      //   padding: `10px 0`,
      // }}
      ref={newsListContainerRef}
    >
      <Link to={'/home/news/' + newsToDisplay[0].url}>
        <div className="home-layout__news-list__first-news-card">
          <NewsCard news={newsToDisplay[0]} isFirst={true} />
        </div>
      </Link>
      <div className="home-layout__news-list__right">
        {newsToDisplay.splice(1)?.map((news, index) => (
          <Link to={'/home/news/' + news.url} key={index}>
            <div className="home-layout__news-list__news-card">
              <NewsCard news={news} isFirst={false} />
            </div>
          </Link>
        ))}
      </div>

      {/* {newsToDisplay?.map((news, index) => (
        <Link to={'/home/news/' + news.url} key={index}>
          <Card
            className="news-card"
            hoverable
            style={{width: cardWidth, minHeight: 200, margin: `0 ${cardMargin}px`, height: '100%'}}
            cover={
              <img
                style={{width: 300, height: 150, objectFit: 'cover'}}
                alt="image"
                src={news.titlePhotoURL ? news.titlePhotoURL : urlProjectPhoto0}
              />
            }
          >
            <Meta
              title={news.newsName}
              description={
                <span className="news-list-page__list__news__calendar">
                  <CalendarOutlined />
                  <span className="news-list-page__list__news__calendar__text">
                    {dayjs(news.dateOfCreating).format('ll')}
                  </span>
                </span>
              }
            />
          </Card>
        </Link>
      ))} */}
      {/* <Link className="home-top__link" to="/home/news">
        <Button className="home-top__button">
          {props.type === 'news'
            ? intl.formatMessage({id: 'allNews'})
            : intl.formatMessage({id: 'allTutorials'})}
        </Button>
      </Link> */}
      {/* <Button
        type="text"
        style={{color: '#2F5D55', fontSize: '40px', height: '65px', width: buttonSize}}
        onClick={() => {
          setFirstCardIndex(firstCardIndex + 1 < props.newsList.length ? firstCardIndex + 1 : 0)
        }}
      >
        <RightOutlined />
      </Button> */}
    </div>
  )
}
4
